import React, { useRef } from "react";
import { gsap, useGSAP, MOTION_OK } from "../../lib/gsap";
import { timeline } from "../../data/about";
import { Mask } from "./Chrome";

// "2020–2023 Founder & CTO, Workflox" → role + company on separate lines
const splitRole = (role) => {
  const [title, ...rest] = role.split(", ");
  return { title, company: rest.join(", ") };
};

function Career() {
  const root = useRef(null);

  // The glowing line draws itself down the timeline as you scroll
  useGSAP(
    () => {
      const mm = gsap.matchMedia();
      mm.add(MOTION_OK, () => {
        gsap.fromTo(
          ".career-line-fill",
          { scaleY: 0 },
          {
            scaleY: 1,
            ease: "none",
            scrollTrigger: { trigger: ".career-timeline", start: "top 70%", end: "bottom 60%", scrub: true },
          }
        );
      });
      return () => mm.revert();
    },
    { scope: root }
  );

  return (
    <section id="career" className="section" ref={root}>
      <div className="wrap">
        <div className="career-head">
          <p className="eyebrow">Resume</p>
          <h2 className="section-title">
            <Mask>
              My career <em>&amp;</em>
            </Mask>
            <Mask>experience</Mask>
          </h2>
        </div>

        <div className="career-timeline">
          <div className="career-line">
            <div className="career-line-fill" />
          </div>
          {[...timeline].reverse().map((item) => {
            const { title, company } = splitRole(item.role);
            return (
              <div key={item.year} className="career-item" data-reveal>
                <div className="career-meta">
                  <div>
                    <h3>{title}</h3>
                    {company && <h4>{company}</h4>}
                  </div>
                  <span className="career-year">{item.year.replace("–Present", "–Now")}</span>
                </div>
                <p>{item.detail}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Career;
